import React from 'react';
import { Row, Col } from 'antd';
import MerchantSettings from '../components/SettingsEdit/MerchantSettings';
import MerchantDataForm from '../components/SettingsEdit/MerchantDataForm';
import AutoswapDataForm from '../components/SettingsEdit/AutoswapDataForm';
import useWindowSize from '../utils/resizeHook';
import { InstructionCustomURL } from '../components/InstructionCustomURL/InstructionCustomURL';
import { AppConfig } from '../config';
import { connect } from "react-redux";
import SecurityDataForm from "../components/SettingsEdit/SecurityDataForm";
import WebhooksWrapper from "../components/Webhooks/WebhooksWrapper";

const Settings = ({ networkFilter, userRole }) => {
  const { currentWidth } = useWindowSize();

  return (
    <React.Fragment>
      <Row gutter={[20, 20]}>
        <Col span={currentWidth >= 1024 ? 6 : 24}>
        <MerchantSettings />
        {AppConfig.showDomainInstruction && !AppConfig?.hideLogo && <InstructionCustomURL />}
        </Col>
        <Col span={currentWidth >= 1024 ? 18 : 24}>
          <MerchantDataForm />
          {userRole.includes('corporate') && <SecurityDataForm />}
          {networkFilter === 'mainnet' && <AutoswapDataForm />}
          <WebhooksWrapper />
        </Col>
      </Row>
    </React.Fragment>
  );
}

const mapStateToProps = state => ({
  networkFilter: state.networkFilter,
  userRole: state.user.data.roles,
});

export default connect(mapStateToProps, null)(Settings);
